/* eslint-disable fp/no-throw */
export const EJ_NPOS_REQUEST = {
  PRINT_RECEIPT: 'EJ_NPOS_PRINT_RECEIPT_REQUEST',
  REPRINT_RECEIPT: 'EJ_NPOS_PRINT_RECEIPT_REQUEST_FOH',
  REPRINT_RECEIPT_V2: 'EJ_NPOS_PRINT_RECEIPT_REQUEST_FOH_V2',
  RETURN: 'EJ_TRANSACTION_ORDER_ID',
  TOKEN: 'EJ_NPOS_TOKEN_REQUEST',
};

const getMessageObject = (message, payload) => (payload ? { [message]: payload } : { message });

export const postWkMessage = (msg, payload) => {
  if (!window.webkit?.messageHandlers?.EjIntegrationMessageHandler) {
    const webkitError = new Error('window.webkit.messageHandler.EjIntegrationMessageHandler is not supported');
    throw webkitError;
  }

  const messageObj = getMessageObject(msg, payload);
  if (messageObj) window.webkit.messageHandlers.EjIntegrationMessageHandler.postMessage(messageObj);
};
